export enum ListingModalTypeEnum {
  AcceptBid = 'accept-bid',
  LowerReserve = 'lower-reserve',
  HoldReserve = 'hold-reserve',
  ViewPaymentDetails = 'view-payment-details',
  ReferredInfo = 'referred-info',
}

export type ListingModalType = ListingModalTypeEnum;

export type LowerReserveModalListingType = 'auction' | 'referred';

type BaseModalData<T> = {
  secondaryData?: T;
};

export type AcceptBidModalData = {
  currentBidText: string;
  lotSku: string;
};

export type LowerReserveModalData = {
  bid: number;
  listingType: LowerReserveModalListingType;
  reserve: number;
  lotSku: string;
  remainingActionCount: number;
};

export type HoldReserveModalData = BaseModalData<AcceptBidModalData> & {
  lotSku: string;
};

export type ViewPaymentDetailsModalData = {
  lotSku: string;
};

export type ReferredInfoModalData = {};

export type ListingModalData<T extends ListingModalType> =
  T extends ListingModalTypeEnum.AcceptBid
    ? AcceptBidModalData
    : T extends ListingModalTypeEnum.LowerReserve
    ? LowerReserveModalData
    : T extends ListingModalTypeEnum.ViewPaymentDetails
    ? ViewPaymentDetailsModalData
    : T extends ListingModalTypeEnum.ReferredInfo
    ? ReferredInfoModalData
    : HoldReserveModalData;

export type ModalContentPayload<T extends ListingModalType> = {
  type: T;
  data: ListingModalData<T>;
};

export type SetModalContent = <T extends ListingModalType>({
  type,
  data,
}: ModalContentPayload<T>) => void;

export type SetModalContentType<T extends ListingModalType> = ({
  type,
  data,
}: ModalContentPayload<T>) => void;

export function isLowerReserve(
  modalType: ListingModalType
): modalType is ListingModalTypeEnum.LowerReserve {
  return modalType === ListingModalTypeEnum.LowerReserve;
}

export function isLowerReservePayload(
  payload: ModalContentPayload<any>
): payload is ModalContentPayload<ListingModalTypeEnum.LowerReserve> {
  return isLowerReserve(payload.type);
}

export function isAcceptBid(
  modalType: ListingModalType
): modalType is ListingModalTypeEnum.AcceptBid {
  return modalType === ListingModalTypeEnum.AcceptBid;
}

export function isAcceptBidPayload(
  payload: ModalContentPayload<any>
): payload is ModalContentPayload<ListingModalTypeEnum.AcceptBid> {
  return isAcceptBid(payload.type);
}

export function isHoldReserve(
  modalType: ListingModalType
): modalType is ListingModalTypeEnum.HoldReserve {
  return modalType === ListingModalTypeEnum.HoldReserve;
}

export function isHoldReservePayload(
  payload: ModalContentPayload<any>
): payload is ModalContentPayload<ListingModalTypeEnum.HoldReserve> {
  return isHoldReserve(payload.type);
}

export function isViewPaymentDetails(
  modalType: ListingModalType
): modalType is ListingModalTypeEnum.ViewPaymentDetails {
  return modalType === ListingModalTypeEnum.ViewPaymentDetails;
}

export function isViewPaymentDetailsPayload(
  payload: ModalContentPayload<any>
): payload is ModalContentPayload<ListingModalTypeEnum.ViewPaymentDetails> {
  return isViewPaymentDetails(payload.type);
}

export function isReferredInfo(
  modalType: ListingModalType
): modalType is ListingModalTypeEnum.ReferredInfo {
  return modalType === ListingModalTypeEnum.ReferredInfo;
}

export function isReferredInfoPayload(
  payload: ModalContentPayload<any>
): payload is ModalContentPayload<ListingModalTypeEnum.ReferredInfo> {
  return isReferredInfo(payload.type);
}
